// サイトの演出はOSの「視差効果を減らす」と連動させない。
// 既存の演出コントローラーへ、通常再生の方針を共通で渡す。
export const siteMotion = Object.freeze({
  matches: false,
  addEventListener() {},
  removeEventListener() {},
});
